import React from "react";
import { useSelector } from "react-redux";
import { accessOptions, checkWorkSpaceFromCookies, switchToBrandAccess, switchWorkspace } from "../../../api_calls/userManagement";
import { useNavigate } from "react-router-dom";
import { fetchWorkSpaceList } from "../../../api_calls/requestConfig";
import AccessSelection from "./AccessSelection";

const WorkSpace = ({ open, onClose, usedFor }) => {
  const currentStateData = useSelector((state) => state.userSelections);
  const [selectedWorkSpace, setSelectedWorkSpace] = React.useState("");
  const checkWorkspaceOptions = accessOptions();
  const workspaceOptionsLoaded = typeof currentStateData.workspace_options !== "undefined";
  
  const navigate = useNavigate();
  React.useEffect(() => {
    const checkWorkSpaces = checkWorkSpaceFromCookies();
    const workspaceOptions = accessOptions();
    if (
      checkWorkSpaces.success === true &&
      typeof checkWorkSpaces.current_workspace !== "undefined" &&
      typeof checkWorkSpaces.current_workspace.id !== "undefined"
    ) {
      const currentWorkspaceIsSelectable = workspaceOptions.some((workspaceOption) => {
        return workspaceOption.value === checkWorkSpaces.current_workspace.id;
      });
      setSelectedWorkSpace(currentWorkspaceIsSelectable === true ? checkWorkSpaces.current_workspace.id : "");
    }

    if (workspaceOptionsLoaded === false) {
      fetchWorkSpaceList(navigate);
    }
  }, [navigate, workspaceOptionsLoaded]);

  return (
    <AccessSelection
      open={open}
      title="Workspace Selection"
      description="You have access to workspaces of multiple retailers. Select which workspace you would like to enter."
      options={checkWorkspaceOptions}
      initialSelection={selectedWorkSpace}
      showCancel={usedFor === "update"}
      onCancel={onClose}
      onEnter={(workSpace) => {
        setSelectedWorkSpace(workSpace.value);
        if (workSpace.value === "brandAccess") {
          switchToBrandAccess(navigate, usedFor);
        } else {
          switchWorkspace(workSpace.value, navigate, usedFor);
        }
      }}
    />
  );
};

export default WorkSpace;
